import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
let UserCalendarModel = (_dec = attr('number'), _dec2 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec3 = belongsTo('contact', {
  inverse: 'user_calendars',
  async: false
}), _dec4 = attr('boolean', {
  defaultValue: false
}), _class = class UserCalendarModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "calendar_rank", _descriptor, this);
    _initializerDefineProperty(this, "user_to_show", _descriptor2, this);
    _initializerDefineProperty(this, "user", _descriptor3, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "calendar_rank", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "user_to_show", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "user", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { UserCalendarModel as default };
//# sourceMappingURL=user-calendar.js.map
